import React, { Component } from "react";
import { Localization } from "../common/Localization";
import LoadingPanel from "../common/LoadingPanel";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Form, Field } from "react-final-form";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { expediciaController } from "../../controllers/expedicia.controller";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import confirmService from "../common/confirmService";
import vyberPoziceGlsStitkyService from "../common/vyberPoziceGlsStitkyService";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum, SposobDopravy } from "../../enums";

const formValidation = values => {
    const errors = {};

    if (!values.sposobDopravyItem) {
        errors.sposobDopravyItem = "Spôsob dopravy je povinná položka.";
    }

    return errors;
};

class ExpedovatDialogContent extends Component {
    state = {
        data: null,
        loading: true
    };

    componentDidMount() {
        expediciaController.getForCreate(this.props.selectedBalikIds).then(async (response) => {
            var continueExpedicia = true;
            if (response.isQuestion) {
                const confirmResult = await confirmService.show({
                    type: MessageTypeEnum.QUESTION,
                    message: response.errorMessage,
                    buttons: ButtonGroupEnum.YES_NO
                });
                continueExpedicia = confirmResult == ButtonMessageEnum.YES;
            }

            if (continueExpedicia) {
                this.setState({
                    data: response,
                    loading: false
                });
                this.props.switchKeyboardEventHandler(true);
            } else {
                this.props.toggleDialog();
            }
        });
    }

    onSubmit(values) {
        var dialog = document.getElementById("ExpediciaDialog");
        var button = dialog.getElementsByClassName("save-button")[0];
        var window = document.getElementsByClassName("k-widget k-window k-dialog")[0];
        var closeButton = window.getElementsByClassName("k-dialog-close")[0];
        button.disabled = true;
        closeButton.disabled = true;
        expediciaController.saveExpedicia(values).then(async (response) => {
            if (response.errorMessage) {
                button.disabled = false;
                closeButton.disabled = false;
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage
                });
            } else {
                this.props.switchKeyboardEventHandler(false);
                this.props.toggleDialog();
                this.props.reloadGrid(async () => {
                    if (response.idExpedicia > 0) {
                        if (response.printParcelLabels == true && values.sposobDopravyItem.toUpperCase() == SposobDopravy.GLS) {
                            const result = await vyberPoziceGlsStitkyService.show({ logMessage: true });
                            if (result.button == ButtonMessageEnum.OK) {
                                this.props.printGlsExpediciaStitky(response.idExpedicia, result.value);
                            }
                        }
                        if (values.tiskPotvrdenia) {
                            this.props.printPotvrdeniePreVodica(response.idExpedicia);
                        }
                        await confirmService.show({
                            message: "Expedícia bola úspešne zaevidovaná !"
                        });
                    }
                });
            }
        });
    }

    renderDialogContent() {
        var localizationService = provideLocalizationService(this);

        return this.state.data.isError ? (
            <div className="alert alert-danger">{this.state.data.errorMessage}</div>
        ) : (
            <div id="ExpediciaDialog">
                <Form
                    validate={formValidation}
                    onSubmit={(values) => this.onSubmit(values)}
                    initialValues={this.state.data}
                    render={({ form, handleSubmit }) => (
                        <React.Fragment>
                            <div className="row">
                                <div className="col-xs-12">
                                    <Grid data={this.state.data.souhrnnyPrehlad} className="ExpediciaGrid">
                                        <GridColumn field="skladNazov" title={localizationService.toLanguageString("ExpedíciaFRM.Príjemca", "Príjemca")} />
                                        <GridColumn field="typTovaru" title={localizationService.toLanguageString("ExpedíciaFRM.Typ tovaru", "Typ tovaru")} />
                                        <GridColumn field="balikov" title={localizationService.toLanguageString("ExpedíciaFRM.Balíkov", "Balíkov")} />
                                        <GridColumn field="spoluKs" title={localizationService.toLanguageString("ExpedíciaFRM.Kusov", "Kusov")} />
                                    </Grid>
                                </div>
                            </div>
                            <form id="ExpediciaForm" onSubmit={handleSubmit} className="k-form">
                                <fieldset>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="k-form-field expedice-pocet">
                                                <span>
                                                    {localizationService.toLanguageString(
                                                        "ExpedíciaFRM.Počet expedovaných balíkov:",
                                                        "Počet expedovaných balíkov:"
                                                    )}{" "}
                                                    {this.state.data.pocet}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <Field name="sposobDopravyItem">
                                            {({ input, meta }) => (
                                                <div className="k-form-field expedice-sposob-dopravy">
                                                    <div className="col-xs-4">
                                                        {localizationService.toLanguageString("ExpedíciaFRM.Spôsob dopravy", "Spôsob dopravy")}
                                                    </div>
                                                    <div className="col-xs-8">
                                                        <ComboBox {...input} data={this.state.data.sposobDopravyItems} allowCustom={true} />
                                                        {meta.error && meta.touched && <span className="k-required">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-8">
                                            <Field name="tiskPotvrdenia">
                                                {({ input, meta }) => (
                                                    <div className="expedice-tisk-potvrdenia">
                                                        <input {...input} type="checkbox" value="true" />
                                                        <span>
                                                            {localizationService.toLanguageString(
                                                                "ExpedíciaFRM.Vytlačiť potvrdenie o prevzatí dodávky (2x)",
                                                                "Vytlačiť potvrdenie o prevzatí dodávky (2x)"
                                                            )}
                                                        </span>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="col-xs-4 button-bar text-right">
                                            <Button icon="save" onClick={handleSubmit} className="font-bold auto-focus save-button">
                                                <Localization messageKey={"ExpedíciaFRM.Uložiť"} defaultMessage={"Uložiť"} />
                                            </Button>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </React.Fragment>
                    )}
                />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default ExpedovatDialogContent;

registerForLocalization(ExpedovatDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/ExpedovatDialogContent.js